import { Dispatch } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useNavigate } from 'react-router';
import { Action } from 'redux';

import lang from '../../../../lib/language';
import { setBankAccountDetailsOnCreate } from '../../../../lib/store/crm/index';

import iconCheck from '../../../../assets/bigImages/big-green-check.png';
import Button from '../../../../shared_components/Button/Button';
import { UI_ROUTES } from '../../../../util/routes';

import styles from './AddBankAccountScreen.module.scss';

type Props = {
  isOpen: boolean;
} & ReduxProps;

const AddBankAccountScreen = (props: Props) => {
  const { setBankAccountValuesOnCreate, isOpen } = props;
  const navigate = useNavigate();

  const handleContinue = () => {
    setBankAccountValuesOnCreate();
    navigate(UI_ROUTES.payouts + UI_ROUTES.withdrawalAmount);
  };
  return (
    <>
      {isOpen && (
        <div className={styles.wrapper}>
          <div className={styles.contentWrapper}>
            <div className={styles.imageWrapper}>
              <img className={styles.image} src={iconCheck} alt="Everything is done!" />
            </div>
            <div className={styles.textWrapper}>
              <h6 className={styles.title}>{lang.mobileBankDetailsSetTitle()}</h6>
              <span className={styles.description}>{lang.mobileBankDetailsSetSubtitle1()}</span>
              <div className={styles.secondDescription}>
                <span className={styles.description}>{lang.mobileBankDetailsSetSubtitle2()}</span>
                <span className={styles.description}>{lang.mobileBankDetailsSetSubtitle3()}</span>
              </div>
            </div>
            <div className={styles.buttonWrapper}>
              <div className={styles.continueBtn}>
                <Button fullWidth onClick={handleContinue}>
                  {lang.commonContinueButton()}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  setBankAccountValuesOnCreate: () => dispatch(setBankAccountDetailsOnCreate({})),
});

const connector = connect(null, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(AddBankAccountScreen);
